import React, { useState, useEffect } from "react";
import { Outlet, NavLink } from "react-router-dom";
import "./Dashboard.css";
import { FaSignOutAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import apiClient from "../../api";

const DashboardLayout = ({ onLogout }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [pendingCount, setPendingCount] = useState(0);

    // Fetch pending pandit count for the badge
    useEffect(() => {
        const loadPendingCount = async () => {
            try {
                const response = await apiClient.get("/api/pandit/admin/approval-stats/");
                setPendingCount(response.data.pending || 0);
            } catch (error) {
                // Silently fail - endpoint may not be deployed yet
                setPendingCount(0);
            }
        };

        loadPendingCount();
        const interval = setInterval(loadPendingCount, 30000);
        return () => clearInterval(interval);
    }, []);

    const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);
    const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

    const handleNavClick = () => {
        setIsMobileMenuOpen(false);
    };

    // Navigation items with route paths
    const navItems = [
        { path: "dashboard", label: "Dashboard", icon: "📊" },
        { path: "aarti", label: "Aarti Management", icon: "🕯️" },
        { path: "pathh", label: "Pathh Management", icon: "📖" },
        { path: "chalisa", label: "Chalisa Management", icon: "📜" },
        { path: "bhajan", label: "Bhajan Management", icon: "🎵" },
        { path: "pujas", label: "Puja List", icon: "🛕" },
        { path: "users", label: "User Management", icon: "👥" },
        { path: "pandits", label: "Pandit Management", icon: "🧘‍♂️" },
        { path: "pandit-approvals", label: "Pandit Approvals", icon: "✔️", badge: pendingCount },
        { path: "horoscope", label: "Horoscope Management", icon: "🔮" },
        { path: "mantras", label: "Mantras", icon: "🔊" },
        { path: "panchang", label: "Panchang", icon: "🗓️" },
        { path: "notifications", label: "Notifications", icon: "🔔" },
        { path: "referrals", label: "Referrals", icon: "🔗" },
        { path: "transactions", label: "Transactions", icon: "💳" },
        { path: "bookings", label: "Puja Bookings", icon: "📝" },
    ];

    return (
        <div className="dashboard-container">

            {/* Mobile Menu Button */}
            <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                ☰
            </button>

            {/* Mobile Menu Overlay */}
            <div
                className={`mobile-overlay ${isMobileMenuOpen ? "active" : ""}`}
                onClick={toggleMobileMenu}
            />

            {/* Sidebar */}
            <div
                className={`dashboard-sidebar 
          ${isSidebarCollapsed ? "collapsed" : ""} 
          ${isMobileMenuOpen ? "mobile-open" : ""}
        `}
            >
                <div className="sidebar-header">
                    <h1 className="dashboard-title">Admin Dashboard</h1>
                    <p className="dashboard-subtitle">Manage your spiritual content</p>

                    <button className="sidebar-toggle" onClick={toggleSidebar}>
                        {isSidebarCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
                    </button>
                </div>

                {/* Navigation */}
                <nav className="sidebar-nav">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) =>
                                `nav-item ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavClick}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-text">{item.label}</span>

                            {item.badge > 0 && (
                                <span className="nav-badge">{item.badge}</span>
                            )}

                            {isSidebarCollapsed && (
                                <div className="nav-tooltip">{item.label}</div>
                            )}
                        </NavLink>
                    ))}
                </nav>

                {/* Logout */}
                <div className="logout-section">
                    <button onClick={onLogout} className="logout-button">
                        <FaSignOutAlt />
                        <span className="logout-text">Logout</span>
                    </button>
                </div>
            </div>

            {/* Main Content - Outlet renders the matched child route */}
            <main className={`dashboard-main ${isSidebarCollapsed ? "collapsed" : ""}`}>
                <div className="dashboard-content">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default DashboardLayout;
